export const IQGreetings = [
  'Hey, I’m IQ. Got some text for me to start with?',
  'Hi, I’m IQ. What would you like me to look at today?',
  'I’m IQ. Share your words and I’ll take it from there.',
  'Hey, I’m IQ. Want to drop some writing in for me?',
];
